export default __webpack_public_path__ + "static/media/chat-send.61bf34ac.svg";